import styled from "styled-components";

export const LayoutShell = styled.div`
  height: 100vh;
  height: 100dvh;
  min-height: 100vh;
  overflow: hidden;

  @media (min-width: 1024px) {
    padding-left: 16.5rem;
  }

  @media (min-width: 1280px) {
    padding-left: 18.75rem;
  }
`;

export const LayoutColumn = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
  width: 100%;
`;

export const StickyHeaderWrap = styled.div`
  flex-shrink: 0;
  position: relative;
  z-index: 30;
  padding: 0.75rem;
  background: var(--brand-shell-background);
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);

  @media (min-width: 640px) {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  @media (min-width: 768px) {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  @media (min-width: 1024px) {
    padding-left: 2rem;
    padding-right: 2rem;
  }
`;

export const HeaderStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export const HeaderRow = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: nowrap;
  gap: 0.5rem 0.75rem;
  justify-content: space-between;
  min-width: 0;

  @media (max-width: 1023px) {
    /* Clear the fixed mobile nav toggle (left-4 + 2.5rem wide) */
    padding-left: 3.25rem;
  }
`;

export const BreadcrumbWrap = styled.nav`
  align-items: center;
  display: flex;
  flex: 1 1 auto;
  min-height: 1.75rem;
  min-width: 0;
  overflow: visible;
  position: relative;
  z-index: 2;
`;

export const ProfileToggle = styled.button`
  align-items: center;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.03);
  border-radius: 999px;
  box-shadow: var(--brand-profile-shadow);
  color: var(--brand-ink);
  display: inline-flex;
  flex-shrink: 0;
  gap: 0.375rem;
  max-width: 100%;
  min-height: 2.25rem;
  min-width: 0;
  padding: 0.1875rem 0.4375rem 0.1875rem 0.1875rem;
  transition: background 160ms ease, border-color 160ms ease;

  &:hover {
    background: rgba(120, 167, 222, 0.08);
    border-color: rgba(120, 167, 222, 0.12);
  }

  @media (min-width: 640px) {
    gap: 0.5rem;
    min-height: 2.375rem;
    padding: 0.25rem 0.5rem 0.25rem 0.25rem;
  }
`;

export const ProfileCopy = styled.div`
  display: none;
  flex-direction: column;
  gap: 0.0625rem;
  justify-content: center;
  line-height: 1.1;
  min-width: 0;
  text-align: left;

  @media (min-width: 640px) {
    display: flex;
  }
`;

export const DropdownSurface = styled.div`
  background: var(--brand-panel-muted);
  border: none;
  border-radius: 1rem;
  box-shadow: var(--brand-dropdown-shadow);
  max-width: calc(100vw - 1.5rem);
  padding: 0.5rem;
  position: absolute;
  right: 0;
  top: calc(100% + 0.6rem);
  width: 12rem;
  z-index: 50;
`;

export const DropdownAction = styled.button<{ $danger?: boolean }>`
  background: transparent;
  border-radius: 0.75rem;
  color: ${({ $danger }) => ($danger ? "#fecaca" : "var(--brand-ink)")};
  font-size: 0.8125rem;
  padding: 0.5rem 0.75rem;
  text-align: left;
  transition: background 160ms ease;
  width: 100%;

  &:hover {
    background: ${({ $danger }) =>
      $danger ? "rgba(220, 38, 38, 0.14)" : "rgba(240, 191, 86, 0.08)"};
  }
`;

export const SchoolHubSelectorWrap = styled.div``;

export const SchoolHubSelectorCard = styled.div`
  padding-block: 0.5rem;
  padding-inline: 0;
`;

export const SchoolOpsHeaderCard = styled.div`
  padding-block: 0.5rem;
  padding-inline: 0;
`;

export const SchoolOpsPageTitleRow = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: space-between;
  min-width: 0;
`;

export const SchoolOpsPageTitle = styled.h1`
  color: var(--brand-ink);
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.35;
  margin: 0;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (min-width: 640px) {
    font-size: 1.25rem;
  }
`;

export const SchoolOpsPageActions = styled.div`
  align-items: center;
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: flex-end;
`;

export const SchoolOpsTabsWrap = styled.div`
  -webkit-overflow-scrolling: touch;
  overflow-x: auto;
  overscroll-behavior-x: contain;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const SubTabsWrap = styled.div``;

export const SubTabsCard = styled.div`
  backdrop-filter: blur(12px);
  background: rgba(15, 19, 24, 0.82);
  border: none;
  border-radius: 1.5rem;
  box-shadow: var(--brand-shadow);
  padding-block: 0.5rem;
  padding-inline: 0;
`;

export const SubTabsHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  @media (min-width: 1024px) {
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const SubTabsCopy = styled.div`
  min-width: 0;
`;

export const SubTabsScroller = styled.div`
  -webkit-overflow-scrolling: touch;
  overflow-x: auto;
  overscroll-behavior-x: contain;
  padding-bottom: 0.25rem;
  scrollbar-color: rgba(240, 191, 86, 0.52) rgba(255, 255, 255, 0.04);
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    border: none;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.05);
    box-shadow: none;
  }

  &::-webkit-scrollbar-thumb {
    border: none;
    border-radius: 999px;
    background: rgba(240, 191, 86, 0.52);
    box-shadow: none;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(240, 191, 86, 0.64);
  }

  &::-webkit-scrollbar-thumb:active {
    background: rgba(240, 191, 86, 0.76);
  }
`;

export const SubTabsRow = styled.div`
  display: flex;
  gap: 0.5rem;
  min-width: max-content;
  padding-right: 0.125rem;
`;

export const SubTabButton = styled.button<{ $active?: boolean }>`
  background: ${({ $active }) =>
    $active ? "var(--brand-highlight)" : "rgba(255, 255, 255, 0.04)"};
  border: none;
  border-radius: 999px;
  box-shadow: none;
  color: ${({ $active }) => ($active ? "#1b1306" : "rgba(245, 239, 230, 0.82)")};
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.4375rem 0.75rem;
  transition: border-color 160ms ease;

  &:hover {
    background: ${({ $active }) =>
      $active ? "var(--brand-highlight)" : "rgba(120, 167, 222, 0.08)"};
    color: var(--brand-ink);
  }
`;

export const MainContent = styled.main`
  flex: 1;
  min-height: 0;
  min-width: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  padding: 1.25rem 0.75rem 1.5rem;
  /* TODO(#3): Per-route max-width deferred — a global cap on MainContent alone breaks grid
     layouts because Tailwind breakpoints (xl:, 2xl:) key off viewport width, not the content
     container, so column counts no longer match the available width. StickyHeaderWrap also
     stays full-bleed while MainContent is capped, causing header/body misalignment.
     Fix: wrap StickyHeaderWrap + MainContent in a shared inner shell (e.g. max-width: 1600px)
     and migrate page grids to @container queries so column counts follow the shell width. */
  /* max-width: 1280px; */
  /* width: 100%; */

  @media (min-width: 640px) {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  @media (min-width: 768px) {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  @media (min-width: 1024px) {
    padding-left: 2rem;
    padding-right: 2rem;
  }
`;
